/* ONE BOUT — accordion motion (SV45, Svitlana 30. 9.; ref. flite.bike)
   Prestige's <accordion-disclosure> (theme.js) opens in 0.25 s "ease". This module swaps its two animation factories
   for a longer, softer motion — ease-out-quint height with the content gliding in 10px — without touching theme.js
   (the methods are looked up on the prototype at every toggle, so all accordions pick it up: PDP, FAQ, filters…).
   prefers-reduced-motion → instant. Loaded as a module from layout/theme.liquid ("vendor" = the theme's Motion). */
import { timeline } from 'vendor';

const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
const EASE_OUT = [0.22, 1, 0.36, 1];
const EASE_IN_OUT = [0.65, 0, 0.35, 1];

customElements.whenDefined('accordion-disclosure').then(() => {
  const Disclosure = customElements.get('accordion-disclosure');
  if (!Disclosure || Disclosure.prototype.obMotion) return;
  Disclosure.prototype.obMotion = true;

  Disclosure.prototype.createShowAnimationControls = function createShowAnimationControls() {
    const fast = REDUCED.matches;
    this.disclosureElement.style.overflow = 'hidden';
    const controls = timeline([
      [this.disclosureElement, { height: [`${this.summaryElement.clientHeight}px`, `${this.disclosureElement.scrollHeight}px`] }, { duration: fast ? 0 : 0.45, easing: EASE_OUT }],
      [this.contentElement, { opacity: [0, 1], transform: [fast ? 'none' : 'translateY(10px)', 'translateY(0)'] }, { duration: fast ? 0 : 0.35, at: fast ? '<' : '-0.3', easing: EASE_OUT }]
    ]);
    controls.finished.then(() => {
      this.disclosureElement.style.height = null;
      this.disclosureElement.style.overflow = null;
    });
    return controls;
  };

  Disclosure.prototype.createHideAnimationControls = function createHideAnimationControls() {
    const fast = REDUCED.matches;
    const controls = timeline([
      [this.contentElement, { opacity: 0 }, { duration: fast ? 0 : 0.2 }],
      [this.disclosureElement, { height: [`${this.disclosureElement.clientHeight}px`, `${this.summaryElement.clientHeight}px`] }, { duration: fast ? 0 : 0.35, at: '<', easing: EASE_IN_OUT }]
    ]);
    controls.finished.then(() => {
      this.disclosureElement.style.height = null;
    });
    return controls;
  };
});
